<template>
  <div class="search">
    <div v-if="type == 'head'">
      <Input
        style="border: 0px !important"
        v-model="key"
        search
        size="default"
        @on-search="handleSearch"
        @on-focus="isfocus = true"
        @on-blur="isfocus = false"
        :placeholder="$t('search')"
        class="hinput"
        :style="isfocus ? 'width:250px;border:none;' : ''"
      />
    </div>
    <div v-else>
      <Input
        v-model="key"
        size="large"
        @on-search="handleSearch"
        search
        enter-button
        :placeholder="$t('search')"
      />
    </div>
  </div>
</template>

<script>
import { Input } from "iview";
import api from "../common/api";
export default {
  name: "Search",
  props: ["type"],
  components: {
    Input,
  },
  data() {
    return {
      isfocus: false,
      key: "",
    };
  },
  methods: {
    handleSearch() {
      if (this.key) {
        const kw = this.key;
        if (kw.length <= 15) {
          let reg = /^[0-9]*$/;
          if (reg.test(kw)) {
            this.$router.push("/block/detail?block=" + kw);
          } else {
            const KW = kw.toLocaleUpperCase();
            this.$axios({
              url: api.secondCurrencyDetail,
              method: "get",
              params: {
                currency: KW,
              },
            })
              .then((res) => {
                let data = res.data;
                let address = data.counterparty;
                this.$router.push(
                  "/assets/detail?currency=" +
                    KW +
                    "&issuer=" +
                    data.counterparty
                );
              })
              .catch((err) => {
                this.$router.push("/err?err=currency");
              });
          }
        }
        if (kw.length > 15 && kw.length <= 40 && this.key.indexOf("6") == 0) {
          this.$router.push({ path: "/account", query: { address: kw } });
        }
        if (kw.length > 40) {
          this.$router.push({ path: "/hash", query: { hash: kw } });
        }

        this.key = "";
      } else {
        //输入框拉长时，如无内容，提示无输入内容
        if (this.isfocus === false) {
          this.$Message.warning(this.$t("searcherr"));
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.search {
  background: transparent !important;
  display: inline-block;
  .hinput {
    width: 186px;
    transition: all 500ms;
  }
  .ivu-input-search-icon {
    background: none !important;
    color: #51a1ff !important;
  }
  .ivu-input:hover {
    border-color: #a2c2f7 !important;
  }
  .ivu-input {
    border: 0px !important;
    font-size: 10px;
  }
  .ivu-input-search-icon {
    background: none !important;
    color: #a3c1f5 !important;
    border-radius: 0 4px 4px 0;
    font-size: 26px;
    margin-left: -5px;
  }
}
/deep/.ivu-input {
  font-size: 12px;
  text-indent: 20px;
  border-color: #a2c2f7;
  color: #fff;
  text-indent: 18px;
  padding-left: 20px;
  // border-color:@sdc-mainColor2;
  &:focus {
    border: none;
    border-color: none;
    border-left: none;
    border-top: none;
    border-right: none;
    border-radius: 0px;
    box-shadow: none;
    border-bottom: 1px solid #a2c2f7;
    text-indent: 18px;
  }
  &:hover {
    border-bottom: 1px solid #a2c2f7;
    border-color: none;
    border-left: none;
    border-top: none;
    border-right: none;
    text-indent: 18px;
    border-radius: 0px;
  }
  &::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #a3c1f5;
  }
  &:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #a3c1f5;
  }
  &::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #a3c1f5;
  }
  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #a3c1f5;
  }
}
/deep/.ivu-input-with-search:hover .ivu-input {
  border-color: #e97a8f;
  border-left: none;
  border-top: none;
  border-right: none;
  border-radius: 0px;
}
/deep/.ivu-input-with-suffix {
  border-left: none;
  border-top: none;
  border-right: none;
  border-radius: 0px;
  background: transparent;
}
/deep/.ivu-input-icon {
  left: 0;
}

/deep/.ivu-input-search {
  background: #e4526d !important;
  border-color: #e4526d !important;
  border-left: none;
  border-top: none;
  border-right: none;
  border-radius: 0px;
  &:hover {
    border-left: none;
    border-top: none;
    border-right: none;
    border-radius: 0px;
  }
}
</style>
